/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Copy_LinkInputs */

const en_failed_to_copy_link = /** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy link`)
};

const es_failed_to_copy_link = /** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al copiar el enlace`)
};

const fr_failed_to_copy_link = /** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la copie du lien`)
};

const de_failed_to_copy_link = /** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link konnte nicht kopiert werden`)
};

const id_failed_to_copy_link = /** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menyalin tautan`)
};

/** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */
const ja_failed_to_copy_link = en_failed_to_copy_link;

/** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */
const zh_failed_to_copy_link = en_failed_to_copy_link;

/** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */
const ar_failed_to_copy_link = en_failed_to_copy_link;

/** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */
const it_failed_to_copy_link = en_failed_to_copy_link;

/** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */
const ru_failed_to_copy_link = en_failed_to_copy_link;

/** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */
const pt_failed_to_copy_link = en_failed_to_copy_link;

/** @type {(inputs: Failed_To_Copy_LinkInputs) => LocalizedString} */
const ko_failed_to_copy_link = en_failed_to_copy_link;

/**
* | output |
* | --- |
* | "Failed to copy link" |
*
* @param {Failed_To_Copy_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_copy_link = /** @type {((inputs?: Failed_To_Copy_LinkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Copy_LinkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_copy_link(inputs)
	if (locale === "es") return es_failed_to_copy_link(inputs)
	if (locale === "fr") return fr_failed_to_copy_link(inputs)
	if (locale === "de") return de_failed_to_copy_link(inputs)
	if (locale === "ja") return ja_failed_to_copy_link(inputs)
	if (locale === "zh") return zh_failed_to_copy_link(inputs)
	if (locale === "ar") return ar_failed_to_copy_link(inputs)
	if (locale === "id") return id_failed_to_copy_link(inputs)
	if (locale === "it") return it_failed_to_copy_link(inputs)
	if (locale === "ru") return ru_failed_to_copy_link(inputs)
	if (locale === "pt") return pt_failed_to_copy_link(inputs)
	return ko_failed_to_copy_link(inputs)
});